<template>
	<div class="chat-setting-container">
		<div class="chat-setting-menu">
			<chat-setting-menu @setting-menu-call="menuCll($event)"></chat-setting-menu>
		</div>
		<div class="chat-setting-page">
			<component :is="menuComp"></component>
		</div>
	</div>
</template>

<script>
	import ChatSettingMenu from './ChatSettingMenu.vue'
	import ChatSettingBasic from './ChatSettingBasic.vue'
	import ChatSettingCache from './ChatSettingCache.vue'
	
	export default{
		name:'ChatSettingHome',
		components:{
			ChatSettingMenu,
			ChatSettingBasic,
			ChatSettingCache
		},
		data(){
			return{
				menuComp:'ChatSettingBasic'
			}
		},
		methods:{
			// 菜单点击回调
			menuCll(val){
				if(val == 'basic'){
					this.menuComp = 'ChatSettingBasic'
				}else if(val == 'cache'){
					this.menuComp = 'ChatSettingCache'
				}
			}
		}
	}
</script>

<style>
	.chat-setting-container{
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
	}
	.chat-setting-container .chat-setting-menu{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 150px;
	}
	.chat-setting-container .chat-setting-page{
		position: absolute;
		top: 0;
		left: 150px;
		bottom: 0;
		right: 0;
	}
</style>
